import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.07964 11.0738C5.28033 10.8396 5.38067 10.7226 5.48598 10.6494C5.80605 10.4271 6.22613 10.4109 6.56232 10.6081C6.67292 10.6729 6.78195 10.7819 7 11C7.21805 11.2181 7.32708 11.3271 7.39193 11.4377C7.58907 11.7739 7.57294 12.194 7.3506 12.514C7.27745 12.6193 7.16038 12.7197 6.92625 12.9204L1.53688 17.5398C1.23393 17.7995 0.782138 17.7821 0.5 17.5C0.217862 17.2179 0.200511 16.7661 0.460179 16.4631L5.07964 11.0738Z",
		fill: "currentColor",
		fillOpacity: .6
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.3029 1.69705C10.897 1.10303 11.194 0.806018 11.5365 0.694736C11.8377 0.596849 12.1623 0.596849 12.4635 0.694736C12.806 0.806018 13.103 1.10303 13.6971 1.69706L16.3029 4.30294C16.897 4.89697 17.194 5.19398 17.3053 5.53647C17.4032 5.83774 17.4032 6.16226 17.3053 6.46353C17.194 6.80602 16.897 7.10303 16.3029 7.69706L13.5342 10.4658C13.3349 10.6651 13.2353 10.7647 13.1514 10.8759C13.0769 10.9747 13.0117 11.0801 12.9567 11.191C12.8948 11.3157 12.8502 11.4494 12.7611 11.7167L11.8187 14.544C11.5476 15.3572 11.4121 15.7638 11.1591 15.9516C10.9383 16.1156 10.6597 16.1814 10.3888 16.1335C10.0786 16.0786 9.77555 15.7755 9.1694 15.1694L2.83059 8.8306C2.22445 8.22445 1.92138 7.92138 1.86651 7.61119C1.81861 7.34033 1.88438 7.06169 2.04837 6.84085C2.23616 6.58795 2.64277 6.45241 3.456 6.18133L6.28335 5.23888C6.55062 5.14979 6.68426 5.10525 6.80905 5.04329C6.91987 4.98827 7.02534 4.92308 7.12412 4.84857C7.23534 4.76466 7.33495 4.66505 7.53416 4.46584L10.3029 1.69705Z",
		fill: "currentColor"
	})] })
});
const ForwardRef = forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
